export default class NetworkDropdown {

    constructor($view) {
        this.$view = $view;
        this.opened = false;
        this.toggleLink = this.$view.find('.active_link_reseau');
        this.bind();
    }

    bind() {

        this.toggleLink.on('click', (e) => {
            e.preventDefault()
            this.$view.toggleClass('opened')
            this.opened = !this.opened
            document.dispatchEvent(new CustomEvent('close-main-nav'))
        })

        document.addEventListener('click', (e) => {

            if (this.opened && $(e.target).parent(".network-dropdown.opened").length == 0 && !$(e.target).is('.network-dropdown.opened') ) {
                $(".network-dropdown").toggleClass('opened');
                this.opened = !this.opened;
            }
        });

    }


}


// WEBPACK FOOTER //
// ./public/frontend/js/components/NetworkDropdown.js